(() => {
  const root = document.querySelector(".luma-home");

  if (!root) {
    return;
  }

  const revealElements = [...root.querySelectorAll(".luma-reveal")];
  const protectedPreviews = [...root.querySelectorAll(".luma-protected")];
  const cartForms = [...root.querySelectorAll("[data-luma-add-to-cart]")];
  const floatingCart = root.querySelector(".luma-floating-cart");
  const floatingCartCount = root.querySelector("[data-luma-cart-count]");
  const heroStage = root.querySelector(".luma-hero__stage");

  const reveal = () => {
    revealElements.forEach((element) => element.classList.add("is-visible"));
  };

  if ("IntersectionObserver" in window) {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("is-visible");
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.18 }
    );

    revealElements.forEach((element) => observer.observe(element));
  } else {
    reveal();
  }

  protectedPreviews.forEach((preview) => {
    preview.setAttribute("draggable", "false");
    preview.addEventListener("contextmenu", (event) => event.preventDefault());
    preview.addEventListener("dragstart", (event) => event.preventDefault());
  });

  const refreshCartBubble = (itemCount) => {
    const cartIcon = document.querySelector(".header-actions__cart-icon");

    if (floatingCartCount) {
      floatingCartCount.textContent = String(itemCount);
    }

    if (floatingCart) {
      floatingCart.classList.toggle("is-empty", itemCount === 0);
      floatingCart.classList.remove("is-updated");
      if (itemCount > 0) {
        window.requestAnimationFrame(() => floatingCart.classList.add("is-updated"));
      }
    }

    try {
      sessionStorage.setItem(
        "cart-count",
        JSON.stringify({ value: String(itemCount), timestamp: Date.now() })
      );
    } catch (_) {
      // Storage can be unavailable in private browsing; the cart itself still updates.
    }

    if (cartIcon && typeof cartIcon.renderCartBubble === "function") {
      cartIcon.renderCartBubble(itemCount);
    }
  };

  const initialCartCount = Number((floatingCartCount?.textContent || "0").trim()) || 0;
  refreshCartBubble(initialCartCount);

  cartForms.forEach((form) => {
    const button = form.querySelector("button[type='submit']");
    const label = form.querySelector("[data-luma-cart-label]");
    const feedback = form.querySelector("[data-luma-cart-feedback]");
    const defaultText = label ? label.textContent : "Ajouter au panier";
    const language = () => document.documentElement.getAttribute("data-wallpics-language") || "fr";
    const text = (fr, en) => (language() === "en" ? en : fr);

    form.addEventListener("submit", async (event) => {
      event.preventDefault();

      if (!button || !label) {
        form.submit();
        return;
      }

      button.disabled = true;
      button.classList.remove("is-added");
      label.textContent = text("Ajout...", "Adding...");

      try {
        const addResponse = await fetch("/cart/add.js", {
          method: "POST",
          headers: { Accept: "application/json" },
          body: new FormData(form),
        });

        if (!addResponse.ok) {
          throw new Error("Cart add failed");
        }

        const cartResponse = await fetch("/cart.js", {
          headers: { Accept: "application/json" },
        });
        const cart = await cartResponse.json();

        refreshCartBubble(cart.item_count || 0);
        label.textContent = text("Ajouté - panier ", "Added - cart ") + (cart.item_count || 0);
        button.classList.add("is-added");

        if (feedback) {
          feedback.hidden = false;
        }

        window.setTimeout(() => {
          label.textContent = defaultText;
          button.disabled = false;
          button.classList.remove("is-added");
        }, 1800);
      } catch (_) {
        label.textContent = text("Réessayer", "Try again");
        button.disabled = false;
      }
    });
  });

  document.addEventListener("contextmenu", (event) => {
    if (event.target.closest(".luma-protected")) {
      event.preventDefault();
    }
  });

  window.addEventListener(
    "scroll",
    () => {
      if (!heroStage || window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
        return;
      }

      const progress = Math.min(window.scrollY / 800, 1);
      heroStage.style.transform = `translateY(${progress * 22}px)`;
    },
    { passive: true }
  );
})();
